import * as React from "../_snowpack/pkg/react.js";
import {Modal} from "../_snowpack/pkg/@apsphysics/tesseract-ui-core.js";
import AllSurveysList from "./components/AllSurveysList.js";
import DisplaySurveyResponse from "./components/DisplaySurveyResponse.js";
import FormatDescription from "./components/FormatDescription.js";
const App = ({allSurveys, surveyDict}) => {
  const [idSelected, setIdSelected] = React.useState(null);
  const [filter, setFilter] = React.useState("");
  React.useEffect(() => {
    return () => {
      setIdSelected(null);
      setFilter("");
    };
  }, []);
  function changeFilter(str) {
    setFilter(str.split("").filter((l) => /[a-zA-Z]/.test(l)).join(""));
  }
  return /* @__PURE__ */ React.createElement("div", {
    className: "p-4"
  }, /* @__PURE__ */ React.createElement("h1", {
    className: "text-2xl font-bold text-blue-800"
  }, "Assessing Graduate Programs"), /* @__PURE__ */ React.createElement("h2", {
    className: "text-xl font-bold text-blue-800"
  }, "How does your department support inclusion?"), /* @__PURE__ */ React.createElement("p", {
    className: "py-4"
  }, "The APS", " ", /* @__PURE__ */ React.createElement("a", {
    className: "underline text-blue-700",
    target: "_blank",
    rel: "noreferrer",
    href: "https://www.aps.org/about/governance/committees/cswp/index.cfm"
  }, "Committee on the Status of Women in Physics (CSWP)"), " ", "has facilitated the collection of responses to a series of questions about graduate programs in physics that should be helpful to those interested in assessing the climate for women at various graduate schools. Department chairs (or their assignees) were asked the questions below. All the responses are self-reported by department chairs (or their assignees), and the APS and CSWP assume no responsibility for the accuracy of the information submitted."), /* @__PURE__ */ React.createElement(FormatDescription, null), /* @__PURE__ */ React.createElement("hr", {
    className: "mb-4"
  }), /* @__PURE__ */ React.createElement(AllSurveysList, {
    allSurveys,
    setIdSelected,
    changeFilter,
    filter
  }), /* @__PURE__ */ React.createElement(Modal, {
    ariaHideApp: false,
    isOpen: Boolean(idSelected),
    onRequestClose: () => setIdSelected(null)
  }, idSelected && /* @__PURE__ */ React.createElement(DisplaySurveyResponse, {
    survey: surveyDict[idSelected]
  })));
};
export default App;
